const content = [
  // 第一章 第五节 How to Write
  // 小标题
  {
    key: 'section5',
    type: "title",
    category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "How to Write", // *必填* 标题文本内容
    titleImage: require("@/assets/images/books/book2/title-back.png"),
    textStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
      marginTop: 24,
      marginBottom: 24,
    },
  },
  {
    key: 'section5.1',
    type: "title",
    category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Writing Task", // *必填* 标题文本内容
    titleImageType: 4,
    // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
    textStyle: {
      fontFamily: 'Arial', // 字体，本地配置的字体
      fontSize: 28, // 文字大小  默认：26
      height: 49,
      width: 'auto',
      lineHeight: 49, // 行高  默认：46
      textIndent: 0, // 首行缩进 标题前带图标的写30，不带图标的写20
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      color: '#fff', // 文本颜色  默认：#00a8ac
      backgroundColor: '#5CA683', // 背景颜色  默认：无
      // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
      margin: 24,
      marginTop: 0,
      marginBottom: 0,
      borderRadius: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 48,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
  },
  // 模板样式 单个带边框
  {
    key: 'section5.2',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      marginTop: 0,
      marginBottom: 30,
      padding: 20,
      backgroundColor: '#FFFFFF',
      // paddingTop: 0,
      paddingBottom: 24,
      borderRadius: 0,
    },
    content: [
      {
        key: 'section5.2.1',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Write a Poster for a Festival Party", // *必填* 标题文本内容
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：26
          lineHeight: 38, // 行高  默认：46
          textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
          marginTop: 8,
          marginBottom: 18
        },
      },
      {
        key: 'section5.2.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section5.2.2.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'A poster is a piece of material used to inform its audience about upcoming events such as party performances, lectures, sports meetings, and other activities. If you are a member of the Personnel Department and need to write a poster about a festival party, how will you write it?', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 38, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
    ],
  },
  {
    key: 'section5.3',
    type: "title",
    category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Writing Skills", // *必填* 标题文本内容
    titleImageType: 4,
    // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
    textStyle: {
      fontFamily: 'Arial', // 字体，本地配置的字体
      fontSize: 28, // 文字大小  默认：26
      height: 49,
      width: 'auto',
      lineHeight: 49, // 行高  默认：46
      textIndent: 0, // 首行缩进 标题前带图标的写30，不带图标的写20
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      color: '#fff', // 文本颜色  默认：#00a8ac
      backgroundColor: '#5CA683', // 背景颜色  默认：无
      // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
      margin: 24,
      marginTop: 0,
      marginBottom: 0,
      borderRadius: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 48,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
  },
  // 模板样式 单个带边框
  {
    key: 'section5.4',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      marginTop: 0,
      marginBottom: 44,
      padding: 20,
      backgroundColor: '#FFFFFF',
      // paddingTop: 0,
      paddingBottom: 24,
      borderRadius: 0,
    },
    content: [
      {
        key: 'section5.4.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section5.4.1.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'When writing a poster for a festival party, you can follow the steps outlined below.', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 38, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
      {
        key: 'section5.4.2',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Step 1", // *必填* 标题文本内容
        titleImageType: 3,
        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
          fontFamily: 'Arial', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          height: 49,
          width: 'auto',
          lineHeight: 30, // 行高  默认：46
          maxWidth: 500,
          margin: 0,
          marginTop: 15,
          // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
          // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#fff', // 文本颜色  默认：#00a8ac
          backgroundColor: '#5CA683', // 背景颜色  默认：无
          // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
          borderRadius: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 20,
            borderBottomLeftRadius: 0
          }
        },
      },
      // 模板样式 单个带边框
      {
        key: 'section5.4.3',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 33,
          width: '100%',
          marginTop: -22,
          backgroundColor: '#F0F8F5',
          // paddingTop: 0,
          paddingBottom: 13,
          borderRadius: 10,
          border: 'none',
          borderTop: 'none',
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
        content: [
          {
            key: 'section5.4.3.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.3.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Determine the Key Information About the Poster', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 38, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.3.2', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.3.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Before writing a poster, you should consider the following points.', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 38, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              marginTop: 16,
              marginBottom: 14,
            },
          },
          // 列表
          {
            key: 'section5.4.3.3', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.3.3.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.3.3.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Identify Your Purpose of Writing the Poster: Tell people the information about the party and encourage them to participate in it.', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无   
                  marginBottom: 18,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.3.4', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.3.4.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.3.4.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Know Your Audience: Consider who will be reading your poster.', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 18,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.3.5', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.3.5.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.3.5.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Gather the Information: Gather all the information and decide what information will be included in the poster', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 18,
                },
              },
            ],
          },
        ]
      },
      {
        key: 'section5.4.4',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Step 2", // *必填* 标题文本内容
        titleImageType: 3,
        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
          fontFamily: 'Arial', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          height: 49,
          width: 'auto',
          lineHeight: 30, // 行高  默认：46
          maxWidth: 500,
          margin: 0,
          marginTop: 15,
          // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
          // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#fff', // 文本颜色  默认：#00a8ac
          backgroundColor: '#5CA683', // 背景颜色  默认：无
          // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
          borderRadius: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 20,
            borderBottomLeftRadius: 0
          }
        },
      },
      // 模板样式 单个带边框
      {
        key: 'section5.4.5',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 33,
          width: '100%',
          marginTop: -22,
          backgroundColor: '#F0F8F5',
          // paddingTop: 0,
          paddingBottom: 20,
          borderRadius: 10,
          border: 'none',
          borderTop: 'none',
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
        content: [
          {
            key: 'section5.4.5.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.5.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Establish the Structure of the Poster', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 38, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.5.2', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.5.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Posters are generally composed of three parts: title, body, and signature.', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 38, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              marginTop: 16,
              marginBottom: 14,
            },
          },
          {
            key: 'section5.4.5.3',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
              type: 'flex', // block: 左侧占满 inline：仅第一行有缩进 flex: 左右等高
              width: 72,
              // height: 40,
              text: 'Title',
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: 26, // 文字大小  默认：20
                lineHeight: 38, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#8CB894', // 背景颜色  默认：无
                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
                paddingLeft: 0,
                paddingRight: 0,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
              }
            },
            content: { //右侧文本内容，目前只有一段文字
              key: 'section5.4.5.3.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.4.5.3.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'The title of a poster is attractively placed at the top.It’s better to create the title according to the event, such as “A Party on New Year’s Eve” and “Christmas Party”.', // *必填* 文本内容
                  textStyle: {},
                }
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: 26, // 文字大小  默认：20
                lineHeight: 32, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                backgroundColor: '#FFF', // 背景颜色  默认：无
                padding: 22,
              },
            },
            // 段落内外间距
            paragraphStyle: {
              marginTop: 26,
              marginBottom: 0,
              padding: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }
          },
          {
            key: 'section5.4.5.4',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
              type: 'flex', // block: 左侧占满 inline：仅第一行有缩进 flex: 左右等高
              width: 72,
              // height: 40,
              text: 'Body',
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: 26, // 文字大小  默认：20
                lineHeight: 38, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#8CB894', // 背景颜色  默认：无
                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
                paddingLeft: 0,
                paddingRight: 0,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
              }
            },
            content: { //右侧文本内容，目前只有一段文字
              key: 'section5.4.5.4.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.4.5.4.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'The body gives specific details about the events and is placed in the center. This part usually contains the following key points.', // *必填* 文本内容
                  textStyle: {},
                }
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: 26, // 文字大小  默认：20
                lineHeight: 32, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                backgroundColor: '#FFF', // 背景颜色  默认：无
                padding: 22,
              },
            },
            // 段落内外间距
            paragraphStyle: {
              marginTop: 20,
              marginBottom: 32,
              padding: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }
          },
          // 列表
          {
            key: 'section5.4.5.5', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.5.5.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.5.5.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'State the purpose of the activity clearly. For example, “To celebrate the National Day and enrich the lives of our staff, we plan to hold a party on Saturday night.”', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.5.6', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.5.6.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.5.6.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Give an account of the organizer, the key performances, activities, the date, the time, and the place of the activity. ', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.5.7', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.5.7.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.5.7.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Mention some matters needing attention, such as reminding people to attend the party on time, to be aware of the dress code, or to bring certain items.', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                },
              },
            ],
          },
          {
            key: 'section5.4.5.8',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
              type: 'flex', // block: 左侧占满 inline：仅第一行有缩进 flex: 左右等高
              width: 132,
              // height: 40,
              text: ' Signature',
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: 26, // 文字大小  默认：20
                lineHeight: 38, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#8CB894', // 背景颜色  默认：无
                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
                paddingLeft: 0,
                paddingRight: 0,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
              }
            },
            content: { //右侧文本内容，目前只有一段文字
              key: 'section5.4.5.8.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.4.5.8.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'The signature of a poster usually includes the organizer and the date of issue. The organizer of the poster is usually written in the lower right-hand side of the body, while the date is located on the left side.', // *必填* 文本内容
                  textStyle: {},
                }
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: 26, // 文字大小  默认：20
                lineHeight: 32, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                backgroundColor: '#FFF', // 背景颜色  默认：无
                padding: 22,
              },
            },
            // 段落内外间距
            paragraphStyle: {
              marginTop: 20,
              marginBottom: 0,
              padding: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }
          },
        ]
      },
      {
        key: 'section5.4.6',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: " Step 3", // *必填* 标题文本内容
        titleImageType: 3,
        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
          fontFamily: 'Arial', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          height: 49,
          width: 'auto',
          lineHeight: 30, // 行高  默认：46
          maxWidth: 500,
          margin: 0,
          marginTop: 15,
          // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
          // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#fff', // 文本颜色  默认：#00a8ac
          backgroundColor: '#5CA683', // 背景颜色  默认：无
          // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
          borderRadius: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 20,
            borderBottomLeftRadius: 0
          }
        },
      },
      // 模板样式 单个带边框
      {
        key: 'section5.4.7',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 33,
          width: '100%',
          marginTop: -22,
          backgroundColor: '#F0F8F5',
          // paddingTop: 0,
          paddingBottom: 13,
          borderRadius: 10,
          border: 'none',
          borderTop: 'none',
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
        content: [
          {
            key: 'section5.4.7.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.7.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Revise and Edit', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 38, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.7.2', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.7.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'After you complete the first draft, revise and edit your poster. Check for grammar, spelling, and punctuation errors to ensure that your sentences flow smoothly and convey your message accurately.', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 38, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              marginTop: 16,
              marginBottom: 14,
            },
          },
        ]
      },
      {
        key: 'section5.4.8',
        type: "title",
        category: 9, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Tips for Writing the Poster", // *必填* 标题文本内容
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：26
          width: 'auto',
          lineHeight: 38, // 行高  默认：46
          textIndent: 0, // 首行缩进 标题前带图标的写30，不带图标的写20
          fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#fff', // 文本颜色  默认：#00a8ac
          backgroundColor: '#5CA683', // 背景颜色  默认：无
          // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
          padding: 5,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 5,
          paddingBottom: 5,
          margin: 0,
          marginTop: 20,
          marginBottom: 0,
          borderRadius: {
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
          }
        },
      },
      // 模板样式 单个带边框
      {
        key: 'section5.4.9',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          width: '100%',
          backgroundColor: '#F0F8F5',
          padding: 20,
          paddingTop: 30,
          paddingBottom: 17,
          borderRadius: 10,
          border: '1rem dashed #5CA683',
          borderTop: '1rem dashed #5CA683',
          borderBottom: '1rem dashed #5CA683',
          borderLeft: '1rem dashed #5CA683',
          borderRight: '1rem dashed #5CA683',
        },
        content: [
          {
            key: 'section5.4.9.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.9.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1   Choose the Correct Style of Language', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#5CA683', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.9.2', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.9.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: ' Considering your audience and the theme of the poster, you should strive to choose the correct style of language to approach the audience. The language of the poster about the festival party in the workplace should be straightforward and formal without losing vividness.', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              // marginTop: 16,
              // marginBottom: 14,
            },
          },
          {
            key: 'section5.4.9.3', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.9.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2 Ensure the Authenticity ', // *必填* 文本内容
                textStyle: {},
              },
              {
                key: 'section5.4.9.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '( ', // *必填* 文本内容
                textStyle: {
                  fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
                  fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：normal
                },
              },
              {
                key: 'section5.4.9.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '真实性', // *必填* 文本内容
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
                  fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：normal
                },
              },
              {
                key: 'section5.4.9.3.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: ' ) ', // *必填* 文本内容
                textStyle: {
                  fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
                  fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：normal
                },
              },
              {
                key: 'section5.4.9.3.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'of the Information', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#5CA683', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.9.4', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.9.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'The information contained in the poster must be truthful and clear. You can use some encouraging words appropriately, but should not exaggerate to enhance the effect of the poster.', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              // marginTop: 16,
              // marginBottom: 14,
            },
          },
          {
            key: 'section5.4.9.5', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.9.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3 Use Simple and Concise Sentences to Improve Readability', // *必填* 文本内容
                textStyle: {},
              }
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#5CA683', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.9.6', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.9.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Using simple and concise sentences to convey your main points will attract the readers and urge them to continue reading. Avoid using jargon ( ', // *必填* 文本内容
                textStyle: {},
              },
              {
                key: 'section5.4.9.6.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '行业术语', // *必填* 文本内容
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                },
              },
              {
                key: 'section5.4.9.6.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: ' ) or complicated expressions that may confuse your readers. ', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'Calibri', // 字体，本地配置的字体
              fontSize: 28, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              // marginTop: 16,
              // marginBottom: 14,
            },
          },
        ]
      },
      {
        key: 'section5.4.10',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Sample", // *必填* 标题文本内容
        titleImageType: 3,
        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          height: 50,
          width: 'auto',
          lineHeight: 50, // 行高  默认：46
          maxWidth: 500,
          margin: 0,
          marginTop: 20,
          // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
          fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333333', // 文本颜色  默认：#00a8ac
          backgroundColor: '#F0F8F5', // 背景颜色  默认：无
          border: '1rem solid #5CA683',
          // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
          borderRadius: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 20,
            borderBottomLeftRadius: 0
          }
        },
      },
      //展开收起title
      {
        key: 'section5.4.11',
        type: 'template',
        category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          margin: 0,
          marginTop: 20,
          // marginBottom: 30,
          // padding: 0,
          // paddingTop: 0,
          // paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
        title: '参考翻译 The Lantern Festival Party',
        titleStyle: {
          fontFamily: 'Calibri, 宋体', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          // padding: 0,
          // paddingTop: 0,
          // paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
        content: [
          {
            key: 'section5.4.11.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.11.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '元宵节晚会', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'STXihei', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              marginTop: 12,
            },
          },
          {
            key: 'section5.4.11.2', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.11.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为庆祝元宵节，华远热力有限公司将举办一场元宵节晚会。有关安排如下.', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'STXihei', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.11.3', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.11.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '晚会将于下周六晚上7点到9点在公司宴会厅举行。活动期间，您将欣赏到精彩的歌舞表演、小品和彩灯表演。', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'STXihei', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.11.4', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.11.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '请佩带胸牌，着装得体。我们希望大家都能准时到场欣赏演出。', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'STXihei', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.11.5', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.11.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '华远热力有限公司', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'STXihei', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              textAlign: 'right', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          {
            key: 'section5.4.11.6', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section5.4.11.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2024年5月17日', // *必填* 文本内容
                textStyle: {},
              },
            ],
            textStyle: {
              fontFamily: 'STXihei', // 字体，本地配置的字体
              fontSize: 26, // 文字大小  默认：20
              lineHeight: 42, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              textAlign: 'right', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              marginBottom: 20,
            },
          },
        ],
        contentStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 20,
          paddingTop: 0,
          paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
      },
      // 图片
      {
        key: 'section5.4.12', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        noMargin: 1,
        content: [ // *必填* 图片列表
          {
            key: 'section5.4.12.1', // *必填* 唯一标识
            url: require("@/assets/images/books/book2/content-img-3.png"), // *必填* 图片地址
            // title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-10<\/i>  尺寸线", // 图片标题
            // hasBack: 1,
            // titlePosition: 'top', // 标题位置， 默认为bottom
            heightNoLimit: 1,
            titleStyle: {

            }
          }
        ],
      },
      {
        key: 'section5.4.13',
        type: 'paragraph',
        category: 'withBefore',
        leftMark: { // 左侧标记
          type: 'block', // block: 左侧占满 inline：仅第一行有缩进
          width: 55,
          height: 40,
          text: '',
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: 24, // 文字大小  默认：20
            lineHeight: 40, // 行高  默认：36
            // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#5CA683', // 背景颜色  默认：无
            backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
            paddingLeft: 0,
            paddingRight: 15,
            marginLeft: 0,
            marginRight: 14,
            marginTop: 0,
            marginBottom: 0,
            top: 0,
            left: 0,
          }
        },
        content: { //右侧文本内容，目前只有一段文字
          key: 'section5.4.13.1', // *必填* 唯一标识
          type: 'text', // *必填* 类型：正文
          isInTable: true,
          content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
              key: 'section5.4.13.1.1', // *必填* 唯一标识
              category: 'text', // *必填* 内容类型 text：文本
              text: 'Typical Expressions', // *必填* 文本内容
              textStyle: {
                fontSize: 28, // 文字大小  默认：20
                lineHeight: 38, // 行高  默认：36
                fontFamily: 'Arial', // 字体，本地配置的字体
                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
              },
            }
          ],
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
          },
        },
        // 段落内外间距
        paragraphStyle: {
          marginTop: 34,
          marginBottom: 0,
          padding: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }
      },
      //展开收起title
      {
        key: 'section5.4.14',
        type: 'template',
        category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          margin: 0,
          marginTop: 20,
          // marginBottom: 30,
          // padding: 0,
          // paddingTop: 0,
          // paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
        title: '参考译文',
        titleStyle: {
          fontFamily: '宋体', // 字体，本地配置的字体
          fontSize: 26, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          // padding: 0,
          // paddingTop: 0,
          // paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
        content: [
          // 列表
          {
            key: 'section5.4.14.1', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.1.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.1.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '一场由', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.1.1.2', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                  {
                    key: 'section5.4.14.1.1.3', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（主办方）举办的', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.1.1.4', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                  {
                    key: 'section5.4.14.1.1.5', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（活动）将于', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.1.1.6', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                  {
                    key: 'section5.4.14.1.1.7', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（时间）举行', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.2', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.2.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.2.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '聚会将由', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.2.1.2', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                  {
                    key: 'section5.4.14.2.1.3', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（主办方）举办', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.3', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.3.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.3.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '这个活动旨在', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.3.1.2', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.4', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.4.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.4.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '节目包括', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.4.1.2', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.5', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.5.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.5.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '有关安排如下。', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.6', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.6.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.6.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                  {
                    key: 'section5.4.14.6.1.2', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（活动）将于7月16日星期六晚上7点上演', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.7', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.7.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.7.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '热烈欢迎大家！', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.8', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.8.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.8.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '欢迎任何对这个聚会感兴趣的人参加这个', // *必填* 文本内容
                    textStyle: {},
                  },
                  {
                    key: 'section5.4.14.8.1.2', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '……', // *必填* 文本内容
                    textStyle: {
                      fontFamily: '宋体', // 字体，本地配置的字体
                    },
                  },
                  {
                    key: 'section5.4.14.8.1.3', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（活动）', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.14.9', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.14.9.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.14.9.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '每个人都必须按时参加。', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'STXihei', // 字体，本地配置的字体
                  fontSize: 26, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
        ],
        contentStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 20,
          paddingTop: 0,
          paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
      },
      // 模板样式 单个带边框
      {
        key: 'section5.4.15',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 33,
          width: '100%',
          marginTop: 20,
          backgroundColor: '#F0F8F5',
          paddingTop: 10,
          paddingBottom: 10,
          borderRadius: 0,
          border: 'none',
          borderTop: 'none',
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
        content: [
          // 列表
          {
            key: 'section5.4.15.1', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.1.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.1.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'A… hosted by… will be held in…', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.2', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.2.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.2.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'A party will be given by… ', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.3', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.3.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.3.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'The activity aims to…', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.4', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.4.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.4.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'The program includes...', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.5', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.5.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.5.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'The arrangements are as follows.', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.6', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.6.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.6.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '... will be shown at 7:00 p.m., Saturday, July 16.', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.7', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.7.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.7.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'All are warmly welcome!', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.8', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.8.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.8.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Anyone interested in the party is welcome to...', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
          // 列表
          {
            key: 'section5.4.15.9', // *必填* 唯一标识
            type: 'list', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：ul
            content: [ // *必填* 列表内容
              {
                key: 'section5.4.15.9.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                  {
                    key: 'section5.4.15.9.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Everybody is required/expected to attend it on time.', // *必填* 文本内容
                    textStyle: {},
                  },
                ],
                textStyle: {
                  fontFamily: 'Calibri', // 字体，本地配置的字体
                  fontSize: 28, // 文字大小  默认：20
                  lineHeight: 38, // 行高  默认：36
                  // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无     
                  marginBottom: 22,
                  marginTop: 25,
                },
              },
            ],
          },
        ],
        contentStyle: {
          // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
          // fontSize: 38, // 文字大小  默认：26
          // lineHeight: 40, // 行高  默认：46
          // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          // color: '#5CA683', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
          // marginTop: 30,
          // marginBottom: 30,
          padding: 20,
          paddingTop: 0,
          paddingBottom: 0,
          // borderRadius: 0,
          // border: '',
          // borderTop: '',
          // borderBottom: ''
        },
      },
    ],
  },
  {
    key: 'section5.5',
    type: "title",
    category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Exercise", // *必填* 标题文本内容
    titleImageType: 4,
    // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
    textStyle: {
      fontFamily: 'Arial', // 字体，本地配置的字体
      fontSize: 28, // 文字大小  默认：26
      height: 49,
      width: 'auto',
      lineHeight: 49, // 行高  默认：46
      textIndent: 0, // 首行缩进 标题前带图标的写30，不带图标的写20
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      color: '#fff', // 文本颜色  默认：#00a8ac
      backgroundColor: '#5CA683', // 背景颜色  默认：无
      // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
      margin: 24,
      marginTop: 0,
      marginBottom: 0,
      borderRadius: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 48,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
  },
  // 模板样式 单个带边框
  {
    key: 'section5.6',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      backgroundImage: require("@/assets/images/books/book2/question/question-back.jpg"),
      backgroundSize: 'contain',
      backgroundPosition: 'center bottom',
      marginTop: 0,
      marginBottom: 30,
      padding: 20,
      backgroundColor: '#FFFFFF',
      // paddingTop: 0,
      paddingBottom: 24,
      borderRadius: 0,
    },
    content: [
      {
        key: 'section5.6.1',
        type: 'paragraph',
        category: 'withBefore',
        leftMark: { // 左侧标记
          type: 'block', // block: 左侧占满 inline：仅第一行有缩进
          width: 55,
          height: 40,
          text: '',
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: 24, // 文字大小  默认：20
            lineHeight: 40, // 行高  默认：36
            // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#5CA683', // 背景颜色  默认：无
            backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
            paddingLeft: 0,
            paddingRight: 15,
            marginLeft: 0,
            marginRight: 14,
            marginTop: 0,
            marginBottom: 0,
            top: 0,
            left: 0,
          },
          popContent: { // 气泡
            key: 'section5.6.1.0', // *必填* 唯一标识
            category: 'popover', // *必填* 内容类型 text：文本
            // text: '轴线', // *必填* 文本内容
            textSlot: 1, // 是否以插槽方式引入内容
            // popTitle: '轴线的名词解释',
            popText: '',
            content: [{
              key: 'section5.6.1.0.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'The Mid-Autumn Festival Party', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'A Mid-Autumn Festival party hosted by the Student Union will be held to celebrate the festival build a good campus atmosphere. The arrangements are as follows.', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'The party will be from 6:00 p.m.to 8:00 p.m. next Tuesday at the school gym.', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.4', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.4.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'Enjoy an evening filled with cultural performances, including folk songs, Chinese opera, and instrumental ensembles. Participate in our exciting mooncake-making contest and engage in moon-viewing activities! ', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.5', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.5.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'Bring your friends and classmates, and immerse yourself in the festivities. Let’s come together to celebrate this beautiful tradition under the full moon! ', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.6', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.6.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'We can’t wait to see you there!', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.7', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.7.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'The Student Union', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'right', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },
            {
              key: 'section5.6.1.0.8', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              isInTable: true,
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section5.6.1.0.8.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本
                  text: 'September 29,2025', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'right', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
              },
            },

            ],
            textStyle: {

            },
          },
        },
        content: { //右侧文本内容，目前只有一段文字
          key: 'section5.6.1.1', // *必填* 唯一标识
          type: 'text', // *必填* 类型：正文
          isInTable: true,
          content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
              key: 'section5.6.1.1.1', // *必填* 唯一标识
              category: 'text', // *必填* 内容类型 text：文本
              text: 'Go through the above steps and write a poster for a festival party according to the information given below. You should write at least 80 words but no more than 120 words. ', // *必填* 文本内容
              textStyle: {
                fontSize: 28, // 文字大小  默认：20
                lineHeight: 38, // 行高  默认：36
                fontFamily: 'Arial', // 字体，本地配置的字体
                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
              },
            }
          ],
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
          },
        },
        // 段落内外间距
        paragraphStyle: {
          marginTop: 0,
          marginBottom: 19,
          padding: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }
      },
      // 答题
      {
        key: 'section5.6.2', // *必填* 唯一标识
        type: 'question', // *必填* 类型：答题
        onlyContent: 1, // 只存在内容
        submitBtnStyle: { //按钮的样式
          width: 180,
          height: 52,
          lineHeight: 52, // 行高  默认：46
          backgroundColor: '#F6A84C', // 背景颜色  默认：无
        },
        content: [{
          "topic_id": 57,
          "id": 57,
          "type_id": 4,
          "typenm": "简答题",
          "shorttag": "",
          "showway": "",
          "topic_score": "8.00",
          "isauto": 0,
          "info": "",
          "km": "",
          "stem_url": "",
          "audiofile": "",
          "audiofile_suffix": "",
          "audiofile_title": "附件下载",
          "is_collect": 0,
          "status": 0,
          "is_play": 0,
          "issign": 0,
          "isok": 0,
          "isdone": 0,
          "getscore": 0,
          "comment": "",
          "ischeck": 0,
          "ps_info": "根据相关要求，完成下列题目。",
          "topic_sub": [{
            "shorttag": "",
            "direction": 0,
            "type_id": 4,
            "textareaHeightSize": 'big',
            "typenm": "简答题",
            "score": "8.00",
            "topic_id": 57,
            "sub_id": 1,
            "isauto": 0,
            "is_upload": 0,
            "para44_id": 0,
            "upload_explain": "",
            "options": [],
            "showway": "",
            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:38rem; font-size: 28rem; text-indent: 2em; font-family:Calibri; color: #333; font-weight: normal; font-style: italic; \"><i style=\"font-family:'Calibri';\">A university is planning to hold a Mid-Autumn Festival party to which all students and teachers are invited. <\/i><\/p><p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:38rem; font-size: 28rem; text-indent: 2em; font-family:Calibri; color: #333; font-weight: normal; font-style: italic; \"><i style=\"font-family:'Calibri';\">Please write a poster in the name of the Student Union based on the following information.<\/i><\/p><p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:38rem; font-size: 28rem; text-indent: 2em; font-family:Calibri; color: #333; font-weight: normal; font-style: italic; \"><i style=\"font-family:'Calibri';\">The Purpose of the Party: Celebrate the Mid-Autumn Festival and build a good campus atmosphere.<\/i><\/p><p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:38rem; font-size: 28rem; text-indent: 2em; font-family:Calibri; color: #333; font-weight: normal; font-style: italic; \"><i style=\"font-family:'Calibri';\">Time: 6:00 p.m. to 8:00 p.m. next Tuesday.<\/i><\/p><p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:38rem; font-size: 28rem; text-indent: 2em; font-family:Calibri; color: #333; font-weight: normal; font-style: italic; \"><i style=\"font-family:'Calibri';\">Place: The school gym.<\/i><\/p><p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:38rem; font-size: 28rem; text-indent: 2em; font-family:Calibri; color: #333; font-weight: normal; font-style: italic; \"><i style=\"font-family:'Calibri';\">Activity Arrangements: Cultural performances (folk songs, Chinese opera, and instrumental ensembles); mooncake-making contest; moon-viewing activities.<\/i><\/p>",
            "subanalysis": "",
            "sortid": 1,
            "file_name": "",
            "user_answer": [],
            "brief_answer": {},
            "user_status": -1,
            "answer_img": {},
            "topic_answer": [{
              "topic_id": 57,
              "sub_id": 1,
              "sortid": 1,
              "ask": "",
              "answer": "",
              "askend": null,
              "answer_id": 1,
              "answer_url": "",
              "answertitle": null,
              "score": "8.00",
              "operation_score": 0
            }],
            "video_list": [],
            "isok": 0,
            "isdone": 0,
            "concat_answer": "",
            "user_concat_answer": ""
          }]
        },
        ],
        completeType: '', // 答题完成后的操作 statistics：展示统计结果
      },
    ],
  },
]
export default content